import { ICountry } from 'core/classes/models/IReference'

export interface ICountryWithCluster extends ICountry {
  clusters: string[] | null
}

export interface IHPOrg {
  id: number
  market: string
  region: string
  hpOrg: string
}

export interface IRegion {
  id: number
  region: string
}

export interface IMarket {
  id: number
  region: string
  market: string
}

export interface ICluster {
  id: number
  cluster: string
  region: string
}

export interface IPartnerTerritory {
  countries: ICountryWithCluster[]
  regions: IRegion[]
  hpOrgs: IHPOrg[]
  markets: IMarket[]
  clusters: ICluster[]
}

export const getInitPartnerTerritory = (): IPartnerTerritory => ({
  countries: [],
  regions: [],
  hpOrgs: [],
  markets: [],
  clusters: [],
})
